import React from "react";
import { dailyTargets, targetIndustries } from "../../data/procrmData";

function AgentGuide() {
  return (
    <section className="crm-two-column">
      <div className="procrm-panel">
        <div className="panel-heading">
          <div>
            <span className="eyebrow">Contact Agent Guide</span>
            <h2>Daily operating flow</h2>
          </div>
        </div>

        <div className="agent-flow">
          <div>
            <strong>1. Find leads</strong>
            <p>Use Google Maps and Instagram first. Look for businesses with clear digital gaps.</p>
          </div>
          <div>
            <strong>2. Check before contact</strong>
            <p>Review website, social media, customer journey, Google visibility and enquiry flow.</p>
          </div>
          <div>
            <strong>3. Personalise</strong>
            <p>Mention one real detail about the business before offering the free audit.</p>
          </div>
          <div>
            <strong>4. Offer free audit</strong>
            <p>Lead with the free 3-point digital presence audit, not a hard sell.</p>
          </div>
          <div>
            <strong>5. Track and follow up</strong>
            <p>Every lead must be recorded, with status and follow-up date.</p>
          </div>
        </div>
      </div>

      <div className="procrm-panel">
        <div className="panel-heading">
          <div>
            <span className="eyebrow">Daily Targets</span>
            <h2>Agent activity targets</h2>
          </div>
        </div>

        <div className="crm-report-grid two">
          {dailyTargets.map((item) => (
            <div key={item.task}>
              <span>{item.task}</span>
              <strong>{item.target}</strong>
            </div>
          ))}
        </div>
      </div>

      <div className="procrm-panel crm-wide-panel">
        <div className="panel-heading">
          <div>
            <span className="eyebrow">Best Industries</span>
            <h2>Who to target</h2>
          </div>
        </div>

        <div className="industry-tags">
          {targetIndustries.map((industry) => (
            <span key={industry}>{industry}</span>
          ))}
        </div>
      </div>
    </section>
  );
}

export default AgentGuide;